export default "__VITE_ASSET__CzAV2UKG__"